import Reader from './components/reader.js';

// eslint-disable-next-line no-unused-vars
const theReader = new Reader(document.querySelector('.js-Reader'));
